export var DefaultProjectRole;
(function (DefaultProjectRole) {
    DefaultProjectRole[DefaultProjectRole["Expert"] = 1] = "Expert";
    DefaultProjectRole[DefaultProjectRole["Analyst"] = 2] = "Analyst";
    DefaultProjectRole[DefaultProjectRole["Viewer"] = 3] = "Viewer";
    DefaultProjectRole[DefaultProjectRole["CsLiveOnly"] = 4] = "CsLiveOnly";
    DefaultProjectRole[DefaultProjectRole["Tester"] = 5] = "Tester";
    DefaultProjectRole[DefaultProjectRole["CSM"] = 6] = "CSM";
})(DefaultProjectRole || (DefaultProjectRole = {}));
//# sourceMappingURL=default-projects-roles.js.map